module.exports = __webpack_public_path__ + "img/HCHOmg.3fe8c960.png";